<div *ngIf="systemDetails$ | async as systemDetails" class="layout">
  <div class="main">
    <!-- if unsupported system, add a column in main with statement -->
    <div *ngIf="!systemDetails.isSeSOSupported">
      <sh-card class="unsupported-system-warning">
        <div style="display: flex; align-items: center; gap: 12px">
          <sh-icon icon="warning" size="m" class="warning-icon"></sh-icon>
          <sh-text size="body-1">
            {{ 'limitedSupportDisclaimer.message' | translate }}
          </sh-text>
        </div>
      </sh-card>
    </div>
    <app-cts-gantry-init-status
      *ngIf="ctsGantryVersionService.showCTStatus() | async"
      class="cts-gantry-init"
      [systemDetails]="systemDetails"
    ></app-cts-gantry-init-status>

    <!-- central column (overview) -->
    <app-component-overview-switch></app-component-overview-switch>
  </div>

  <!-- desktop-large -->
  <ng-container *ngIf="screenLayoutService.desktopLarge$ | async">
    <app-spare-parts-panel
      [systemMaterialNumber]="systemDetails.systemMaterialNumber"
      [systemSerialNumber]="systemDetails.systemSerialNumber"
    ></app-spare-parts-panel>
    <div class="widgets">
      <div class="apps-records">
        @if (
          !isAtNeoCorSystem(systemDetails.systemMaterialNumber) &&
          systemDetails.isSeSOSupported
        ) {
          <app-companions-panel
            [systemMaterialNumber]="systemDetails.systemMaterialNumber"
            [systemSerialNumber]="systemDetails.systemSerialNumber"
            [modalityId]="systemDetails.modalityId"
          ></app-companions-panel>
        }
        <sh-card>
          <app-useful-applications [menuMode]="false"></app-useful-applications>
        </sh-card>

        <app-doc-box-panel
          [systemMaterialNumber]="systemDetails.systemMaterialNumber"
          [systemSerialNumber]="systemDetails.systemSerialNumber"
          [modalityId]="systemDetails.modalityId"
        >
        </app-doc-box-panel>
      </div>

      <div class="apps-records">
        <app-planned-activities-panel
          [systemMaterialNumber]="systemDetails.systemMaterialNumber"
          [systemSerialNumber]="systemDetails.systemSerialNumber"
          widgetMode
        ></app-planned-activities-panel>
      </div>
    </div>
  </ng-container>

  <!-- desktop -->
  <ng-container *ngIf="screenLayoutService.desktop$ | async">
    <app-spare-parts-panel
      [systemMaterialNumber]="systemDetails.systemMaterialNumber"
      [systemSerialNumber]="systemDetails.systemSerialNumber"
    ></app-spare-parts-panel>
    <div
      class="widgets"
      [class.widget--no-apps]="
        isAtNeoCorSystem(systemDetails.systemMaterialNumber)
      "
    >
      <app-doc-box-panel
        [systemMaterialNumber]="systemDetails.systemMaterialNumber"
        [systemSerialNumber]="systemDetails.systemSerialNumber"
        [modalityId]="systemDetails.modalityId"
      >
      </app-doc-box-panel>
      @if (
        !isAtNeoCorSystem(systemDetails.systemMaterialNumber) &&
        systemDetails.isSeSOSupported
      ) {
        <app-companions-panel
          [systemMaterialNumber]="systemDetails.systemMaterialNumber"
          [systemSerialNumber]="systemDetails.systemSerialNumber"
          [modalityId]="systemDetails.modalityId"
        ></app-companions-panel>
      }
      <sh-card class="apps">
        <app-useful-applications [menuMode]="false"></app-useful-applications>
      </sh-card>

      <app-planned-activities-panel
        [systemMaterialNumber]="systemDetails.systemMaterialNumber"
        [systemSerialNumber]="systemDetails.systemSerialNumber"
        widgetMode
      ></app-planned-activities-panel>
    </div>
  </ng-container>

  <!-- tablet -->
  <!-- grid, with right column (widgets) below component overview having flex column layout -->
  <ng-container *ngIf="screenLayoutService.tablet$ | async">
    <app-spare-parts-panel
      [systemMaterialNumber]="systemDetails.systemMaterialNumber"
      [systemSerialNumber]="systemDetails.systemSerialNumber"
    ></app-spare-parts-panel>
    <div
      class="right-column"
      [class.right-column--no-apps]="
        isAtNeoCorSystem(systemDetails.systemMaterialNumber)
      "
    >
      <app-doc-box-panel
        [systemMaterialNumber]="systemDetails.systemMaterialNumber"
        [systemSerialNumber]="systemDetails.systemSerialNumber"
        [modalityId]="systemDetails.modalityId"
      >
      </app-doc-box-panel>
      @if (
        !isAtNeoCorSystem(systemDetails.systemMaterialNumber) &&
        systemDetails.isSeSOSupported
      ) {
        <app-companions-panel
          [systemMaterialNumber]="systemDetails.systemMaterialNumber"
          [systemSerialNumber]="systemDetails.systemSerialNumber"
          [modalityId]="systemDetails.modalityId"
        ></app-companions-panel>
      }
      <sh-card class="apps">
        <app-useful-applications [menuMode]="false"></app-useful-applications>
      </sh-card>
      <app-planned-activities-panel
        [systemMaterialNumber]="systemDetails.systemMaterialNumber"
        [systemSerialNumber]="systemDetails.systemSerialNumber"
        widgetMode
      ></app-planned-activities-panel>
    </div>
  </ng-container>

  <!-- phone -->
  <!-- simple flexbox column layout -->
  <ng-container *ngIf="screenLayoutService.phone$ | async">
    @if (
      !isAtNeoCorSystem(systemDetails.systemMaterialNumber) &&
      systemDetails.isSeSOSupported
    ) {
      <app-companions-panel
        [systemMaterialNumber]="systemDetails.systemMaterialNumber"
        [systemSerialNumber]="systemDetails.systemSerialNumber"
        [modalityId]="systemDetails.modalityId"
      ></app-companions-panel>
    }
    <app-spare-parts-panel
      [systemMaterialNumber]="systemDetails.systemMaterialNumber"
      [systemSerialNumber]="systemDetails.systemSerialNumber"
    ></app-spare-parts-panel>
    <app-planned-activities-panel
      [systemMaterialNumber]="systemDetails.systemMaterialNumber"
      [systemSerialNumber]="systemDetails.systemSerialNumber"
      widgetMode
    ></app-planned-activities-panel>
    <app-doc-box-panel
      [systemMaterialNumber]="systemDetails.systemMaterialNumber"
      [systemSerialNumber]="systemDetails.systemSerialNumber"
      [modalityId]="systemDetails.modalityId"
    >
    </app-doc-box-panel>
    <sh-card class="apps">
      <app-useful-applications [menuMode]="false"></app-useful-applications>
    </sh-card>
  </ng-container>
</div>
